(() => {
  const nav = document.querySelector("[data-main-nav]");
  const toggle = document.querySelector("[data-menu-toggle]");

  if (nav && toggle) {
    toggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  document.querySelectorAll("[data-scroll-target]").forEach((button) => {
    button.addEventListener("click", () => {
      const target = document.querySelector(button.getAttribute("data-scroll-target"));
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector("[data-product-main-image]");
    const thumbs = gallery.querySelectorAll("[data-product-thumb]");

    if (!mainImage || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const nextSrc = thumb.getAttribute("data-full");
        if (!nextSrc || mainImage.src === nextSrc) return;

        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");

        mainImage.style.opacity = "0";
        window.setTimeout(() => {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = nextSrc;
          mainImage.alt = thumb.getAttribute("data-alt") || mainImage.alt;
          mainImage.style.opacity = "1";
        }, 140);
      });
    });
  });

  document.querySelectorAll("[data-product-purchase]").forEach((form) => {
    const quantityInput = form.querySelector("[data-quantity-input]");
    const decreaseButton = form.querySelector("[data-quantity-decrease]");
    const increaseButton = form.querySelector("[data-quantity-increase]");
    const variantSelect = form.querySelector('select[name="id"]');
    const bundleOptions = Array.from(form.querySelectorAll("[data-bundle-quantity]"));
    const currentPrice = document.querySelector("[data-current-price]");
    const pricePreview = form.querySelector("[data-price-preview]");
    const discountLabel = pricePreview?.querySelector("[data-discount-label]");
    const totalPrice = pricePreview?.querySelector("[data-total-price]");
    const unitPrice = pricePreview?.querySelector("[data-unit-price]");
    const savingsText = pricePreview?.querySelector("[data-savings-text]");
    const submitNote = form.querySelector("[data-submit-note]");

    if (!quantityInput) return;

    const currency = form.getAttribute("data-currency") || "USD";
    const locale = document.documentElement.lang || "en-US";

    const formatMoney = (cents) => {
      const amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          currencyDisplay: "narrowSymbol",
        }).format(amount);
      } catch (error) {
        return `$${amount.toFixed(2)}`;
      }
    };

    const getUnitPriceCents = () => {
      const selectedOption = variantSelect?.selectedOptions?.[0];
      const selectedPrice = Number(selectedOption?.getAttribute("data-price-cents"));
      if (Number.isFinite(selectedPrice) && selectedPrice > 0) return selectedPrice;

      const basePrice = Number(form.getAttribute("data-base-price-cents"));
      return Number.isFinite(basePrice) ? basePrice : 0;
    };

    const getQuantity = () => {
      const quantity = Number.parseInt(quantityInput.value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    };

    const getDiscountRate = (quantity) => {
      if (quantity >= 3) return 0.1;
      if (quantity >= 2) return 0.05;
      return 0;
    };

    const getBundleLabel = (quantity, discountRate) => {
      if (discountRate > 0) {
        return `${quantity} same-product units - ${Math.round(discountRate * 100)}% preview`;
      }

      return "Single item";
    };

    const getActiveBundleQuantity = (quantity) => {
      if (quantity >= 3) return "3";
      if (quantity >= 2) return "2";
      return "1";
    };

    const updateBundleOptions = (unitCents, quantity) => {
      const activeQuantity = getActiveBundleQuantity(quantity);

      bundleOptions.forEach((option) => {
        const optionQuantity = Number.parseInt(option.getAttribute("data-bundle-quantity"), 10) || 1;
        const optionDiscount = Number(option.getAttribute("data-bundle-discount")) || 0;
        const discountedUnit = Math.round(unitCents * (1 - optionDiscount));
        const preview = option.querySelector("[data-bundle-unit-preview]");
        const isActive = option.getAttribute("data-bundle-quantity") === activeQuantity;

        option.classList.toggle("is-active", isActive);
        option.setAttribute("aria-pressed", String(isActive));

        if (preview) {
          preview.textContent = optionQuantity === 1
            ? formatMoney(unitCents)
            : `${formatMoney(discountedUnit)} each`;
        }
      });
    };

    const updatePricePreview = () => {
      const quantity = getQuantity();
      const unitCents = getUnitPriceCents();
      const discountRate = getDiscountRate(quantity);
      const discountedUnitCents = Math.round(unitCents * (1 - discountRate));
      const fullTotalCents = unitCents * quantity;
      const discountedTotalCents = Math.round(fullTotalCents * (1 - discountRate));
      const savingsCents = Math.max(0, fullTotalCents - discountedTotalCents);

      if (currentPrice) currentPrice.textContent = formatMoney(unitCents);
      if (discountLabel) discountLabel.textContent = getBundleLabel(quantity, discountRate);
      if (totalPrice) totalPrice.textContent = formatMoney(discountedTotalCents);
      if (unitPrice) unitPrice.textContent = formatMoney(discountedUnitCents);
      if (savingsText) {
        savingsText.textContent = savingsCents > 0
          ? `Preview save ${formatMoney(savingsCents)}`
          : "";
      }
      if (submitNote) {
        submitNote.textContent = quantity > 1
          ? `Bundle preview ${formatMoney(discountedTotalCents)}`
          : `Estimated total ${formatMoney(discountedTotalCents)}`;
      }

      updateBundleOptions(unitCents, quantity);
    };

    const setQuantity = (value) => {
      const quantity = Math.max(1, Number.parseInt(value, 10) || 1);
      quantityInput.value = String(quantity);
      updatePricePreview();
    };

    decreaseButton?.addEventListener("click", () => setQuantity(getQuantity() - 1));
    increaseButton?.addEventListener("click", () => setQuantity(getQuantity() + 1));

    bundleOptions.forEach((option) => {
      option.addEventListener("click", () => {
        setQuantity(option.getAttribute("data-bundle-quantity"));
      });
    });

    quantityInput.addEventListener("input", updatePricePreview);
    quantityInput.addEventListener("change", () => setQuantity(getQuantity()));
    variantSelect?.addEventListener("change", updatePricePreview);

    updatePricePreview();
  });
})();
